import { Component, ElementRef, OnInit } from '@angular/core';
import { AccountService } from '../accounts/account.service';
import { Router, ActivatedRoute} from '@angular/router';


@Component({
    providers: [AccountService],
    //templateUrl: 'app/authentication/forgot-password.component.html'
      template: require('./forgot-password.component.html'),
})
 
export class ForgotPasswordComponent implements OnInit {

    public alerts: any[];
    public forgot = 'username';
    public question: any;
    public code: any;
    public email: string;
    public answer: string;
    public newPassword: string;
    private sub: any;
    public sendingEmail: boolean;


    constructor(private router: Router,
        private accountService: AccountService, 
        private route: ActivatedRoute) {}    

    ngOnInit() : void{

        //So for this don't think I need the below currently because we are not doing security questions

        // this.sub = this.route.params.subscribe(
        //     params => {
        //         this.email = params['email'];
        //         this.code = params['code'];
        // });

        // if(this.email){
		// 	this.accountService.getSecurityQuestionForEmail(this.email)
        //         .subscribe(
        //             data => this.question = data.question,
        //             error => {
        //                 this.alerts = [];
		// 				this.alerts.push({type: 'danger', 
		// 					msg: 'An unexpected error occurred while retrieving your security question.'});
        //                 this.timeoutAlert();   
        //             }
        //         );
		// }
    }


    timeoutAlert(){
        setTimeout(() => {
            this.alerts = [];
            //supposedly not needed in angular2
            //$scope.$apply();
        }, 1000);
    }


   
    forgotSomething(){


        
        this.sendingEmail = true;

        let baseUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/'));

        // if(this.forgot === 'username'){
            
        //     this.accountService.retrieveUsername({email: this.email, baseUrl: baseUrl})
        //         .subscribe(
        //             success => {
        //                 this.alerts = [];
        //                 this.alerts.push({type: 'success', msg: 'Your e-mail has been sent.'});                  
        //             },
        //             error => {
        //                 this.alerts = [];
        //                 this.alerts.push({type: 'danger', msg: error});
        //                 this.timeoutAlert();
        //             }
        //         );
        // }
        // else{
            this.accountService.forgotPwd({email: this.email, baseUrl: baseUrl})
                .finally(() => this.sendingEmail = false)
                .subscribe(
                    success => {
                        this.alerts = [];
                        this.alerts.push({type: 'success', msg: 'Your e-mail has been sent.'});                  
                    },
                    error => {
                        this.alerts = [];
                        this.alerts.push({type: 'danger', msg: error});
                        this.timeoutAlert();
                    }
                );
        //}
	}

    closeAlert(index: number) {
    	this.alerts.splice(index, 1);
  	}

    verifySecurityQuestion(){
        this.accountService.verifySecurityQuestion(this.email, this.answer)
            .subscribe(
                data => {
                    if(data === 'true'){
                        this.router.navigate(['/reset-password']);
                    }else{
                        this.alerts = [];
						this.alerts.push({type: 'danger', msg: "The answer doesn't match our records. Please try again."});
					}
                },
                error => {
                    this.alerts = [];
                    this.alerts.push({type: 'danger', msg: 'An unexpected error occurred while verifying your answer.'});    
                },
                () => this.timeoutAlert()
            );						
	}

	resetPassword(){
	    let pwdData = {
		    email: this.email,
			resetToken: this.code,
			newPassword: this.newPassword
		};

		this.accountService.resetPwd(pwdData)
            .subscribe(
                data => {
                    if(data.succeeded){
                        this.router.navigate(['/reset-password-success']);
                    }else{
                        this.alerts = [];
						this.alerts.push({type: 'danger', msg: data.errors[0]});
					}
                },
                error => {
                    this.alerts = [];
                    this.alerts.push({type: 'danger', msg: 'An error occurred resetting your password. Please try again'});    
                },
                () => this.timeoutAlert()

            );
  	}
}





/** WEBPACK FOOTER **
 ** ./app/authentication/forgot-password.component.ts
 **/